// src/components/Card.js
import React from 'react';

const Card = ({ Icon, title, description }) => {
  const cardStyle = {
    background: '#fff',
    padding: '30px',
    borderRadius: '12px',
    boxShadow: '0 5px 20px rgba(0,0,0,0.05)',
    textAlign: 'left',
    transition: 'transform 0.3s ease',
    height: '100%', // Ensure equal height in grid
  };

  const titleStyle = {
    fontSize: '1.2rem',
    fontWeight: '700',
    marginBottom: '15px',
    color: 'var(--text-dark)',
    marginTop: '20px',
  };

  const descStyle = {
    color: 'var(--text-grey)',
    lineHeight: '1.6',
  };

  // Style for the React Icon
  const iconWrapperStyle = {
    color: 'var(--gradient-cyan)', // Using css variable for color
    fontSize: '50px',
  }

  return (
    <div style={cardStyle} className="expertise-card">
      {/* Render the passed Icon component */}
      <div style={iconWrapperStyle}>
        <Icon />
      </div>
      <h3 style={titleStyle}>{title}</h3>
      <p style={descStyle}>{description}</p>
    </div>
  );
};

export default Card;